// extracted by mini-css-extract-plugin
export default {"intervalButtons":"IntervalSelectionButtons_intervalButtons__1xZoD"};